import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProductBentoGrid from "@/components/ProductBentoGrid";
import BrandShowcase from "@/components/BrandShowcase";
import WhyChooseUs from "@/components/WhyChooseUs";
import Gallery from "@/components/Gallery";
import TrustBar from "@/components/TrustBar";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import QuickQuote from "@/components/QuickQuote";

export default function Home() {
  return (
    <SmoothScroll>
      <main
        data-testid="home-page"
        className="relative min-h-screen bg-[#0d1117] text-white"
      >
        <Navbar />
        <HeroSection />
        <EditorialMarquee />
        <ProductBentoGrid />
        <BrandShowcase />
        <WhyChooseUs />
        <Gallery />
        <TrustBar />
        <ContactSection />
        <Footer />
        <WhatsAppFAB />
        <QuickQuote />
      </main>
    </SmoothScroll>
  );
}
